import styled from "styled-components";

export const CommunityContainer = styled.div`
  
`